/**
 * Copyright 2026, IntraLinks, Inc. All rights reserved.
 */

import React, { FC } from 'react';
import { IlModalV2 } from 'il-framework-component';
import { useTranslation } from 'react-i18next';
import { I18nNamespaces } from '../../utils/constants.util';

interface LoaElevationModalProps {
  isOpen: boolean;
  elevating: boolean;
  onContinue: () => void;
  onCancel: () => void;
}

const LoaElevationModal: FC<LoaElevationModalProps> = ({
  isOpen,
  elevating,
  onContinue,
  onCancel
}) => {
  const { t } = useTranslation(I18nNamespaces.LOA_ENRICHMENT);

  const bodyKey = 'loaEnrichment.common.loaElevation.addBody';

  const modalBody = (
    <div id='loa-elevation-body'>
      <p>{t(bodyKey)}</p>
    </div>
  );

  return (
    <IlModalV2
      dialogBody={modalBody}
      size='xs'
      modalHeading={t('loaEnrichment.common.loaElevation.title')}
      open={isOpen}
      onRequestClose={onCancel}
      preventCloseOnClickOutside
      selectorPrimaryFocus='#loa-elevation-body'
      primaryButtonText={t('loaEnrichment.common.loaElevation.continueButton')}
      primaryButtonId='loaElevationContinueBtn'
      primaryButtonClick={onContinue}
      primaryButtonDisabled={elevating}
      secondaryButtonText={t('loaEnrichment.common.buttons.cancel')}
      secondaryButtonId='loaElevationCancelBtn'
      secondaryButtonClick={onCancel}
      tertiaryButtonText=''
    />
  );
};

export default LoaElevationModal;
